import BlocksSubHeader from "../../../components/Blocks/BlocksSubHeader";
import Header from "../../../components/Header/Header";
import LayoutTypeList from "../../../components/LayoutTypeBlock/LayoutTypeList";
import SideNavbar from "../../../components/Navbar/SideNavbar";

const LayoutTypes = () => {
    return (
        <>
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <BlocksSubHeader />
                        <LayoutTypeList />
                    </div>
                </div>
            </div>
        </>
    )
}
export default LayoutTypes;